@if (isOpen) {
    <div class="avatar-modal-backdrop" (click)="close()">
      <div
        class="avatar-modal card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="photoModalTitle"
        (click)="$event.stopPropagation()"
      >
        <!-- Cabeçalho -->
        <div class="card-header d-flex align-items-center justify-content-between">
          <h5 class="mb-0 fw-bold" id="photoModalTitle">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Fechar"
            (click)="close()"
          ></button>
        </div>

        <!-- Corpo -->
        <div class="card-body">
          @if (!imageFile) {
            <!-- Estado vazio: seleção de arquivo -->
            <label class="avatar-dropzone d-flex flex-column align-items-center justify-content-center text-center">
              <i class="ti ti-photo-up avatar-dropzone-icon mb-2"></i>
              <span class="fw-medium mb-1">Selecione uma imagem</span>
              <span class="text-muted small">JPG, PNG ou WebP — até 5 MB</span>
              <input
                type="file"
                class="visually-hidden"
                accept="image/jpeg,image/png,image/webp"
                (change)="onFileSelected($event)"
              />
            </label>
          } @else {
            <!-- Editor: cropper redondo + zoom -->
            <div class="avatar-cropper-wrap">
              <image-cropper
                [imageFile]="imageFile"
                [maintainAspectRatio]="true"
                [aspectRatio]="1"
                [roundCropper]="true"
                [resizeToWidth]="256"
                format="png"
                [transform]="{ scale: zoom }"
                [canvasRotation]="0"
                [alignImage]="'center'"
                (imageCropped)="onImageCropped($event)"
                (imageLoaded)="onImageLoaded($event)"
                (loadImageFailed)="onLoadImageFailed()"
              ></image-cropper>
            </div>

            <!-- Controle de zoom -->
            <div class="d-flex align-items-center gap-2 mt-3">
              <button
                type="button"
                class="btn btn-sm btn-icon btn-light"
                (click)="zoomOut()"
                [disabled]="zoom <= minZoom"
                aria-label="Diminuir zoom"
              >
                <i class="ti ti-minus"></i>
              </button>

              <input
                type="range"
                class="form-range flex-grow-1"
                [min]="minZoom"
                [max]="maxZoom"
                [step]="zoomStep"
                [value]="zoom"
                (input)="onZoomSlider($any($event.target).value)"
                aria-label="Ajustar zoom"
              />

              <button
                type="button"
                class="btn btn-sm btn-icon btn-light"
                (click)="zoomIn()"
                [disabled]="zoom >= maxZoom"
                aria-label="Aumentar zoom"
              >
                <i class="ti ti-plus"></i>
              </button>
            </div>

            <button
              type="button"
              class="btn btn-link btn-sm px-0 mt-2"
              (click)="clearImage()"
            >
              <i class="ti ti-refresh me-1"></i>Escolher outra imagem
            </button>
          }

          @if (loadError) {
            <div class="alert alert-danger mt-3 mb-0 py-2 px-3 small" role="alert">
              {{ loadError }}
            </div>
          }
        </div>

        <!-- Rodapé -->
        <div class="card-footer d-flex justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-light"
            (click)="close()"
            [disabled]="isUploading"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary d-inline-flex align-items-center"
            (click)="save()"
            [disabled]="!imageFile || isUploading"
          >
            @if (isUploading) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Enviando...
            } @else {
              {{ confirmLabel }}
            }
          </button>
        </div>
      </div>
    </div>
  }
